import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickProductsState } from '../../selectors/one-click-products.selector';

export class OneClickProductDisabler extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickProductsState).pipe(
      filter(state => !!state),
      map(state => state.loading),
    );
  }
}
